import "./TheColorPicker.css";
import React from 'react';
import {SketchPicker} from "react-color";

export class TheColorPicker extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      displayColorPicker: false,
      color: this.props.color || undefined
    };
  }

  handleClick() {
    this.setState({displayColorPicker: !this.state.displayColorPicker})
  };

  handleClose() {
    this.setState({displayColorPicker: false})
  };

  handleChange(color) {
    let color1 = undefined;
    if (color.hex !== "#ffffff") {
      color1 = color.hex;
    }
    this.setState({color: color1}, () => {
      this.handleClose();
      this.props.onChange && this.props.onChange(color1);
    });
  };

  render() {

    return (
      <div>
        <div className={"color-swatch"} onClick={() => this.handleClick()}>
          <div className={"color-color"} style={{backgroundColor: this.state.color}}/>
        </div>
        {this.state.displayColorPicker ? <div className={"color-popover"}>
          <div className={"color-cover"} onClick={() => this.handleClose()}/>
          <SketchPicker color={this.state.color} onChange={(data) => this.handleChange(data)}/>
        </div> : null}

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Shared/TheColorPicker.js